import { IdentifierString } from '@iota/wallet-standard';

import { Env } from 'modules/common';

const chains = {
  [Env.dev]: 'iota:testnet',
  [Env.stage]: 'iota:testnet',
  [Env.prod]: 'iota:mainnet',
};

export function getChainIdByEnv(env: Env) {
  return chains[env] as IdentifierString;
}
